import React, { useEffect } from 'react';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import { Navigation } from './components';
import views from './views';
import { Admin } from './admin';
import {
  AlgorithmView,
  UserList,
  UserEdit,
  QuizList,
  QuizEdit,
} from './admin/views';
import { RequireAuth } from './utils/RequireAuth';
import { AdminAuth } from './utils/AdminAuth';
import ScrollToTop from './utils/ScrollToTop';

function App(): JSX.Element {
  useEffect(() => {
    // @ts-ignore: Property does not exist
    analytics.page(window.location.pathname);
  }, []);
  const viewSwitch = (
    <Routes>
      <Route path="/login" element={<views.Login />} />
      <Route path="/verify" element={<views.Verify />} />
      <Route
        path="/admin"
        element={
          <AdminAuth>
            <Admin />
          </AdminAuth>
        }
      >
        <Route path="algorithm" element={<AlgorithmView />} />
        <Route path="users" element={<UserList />} />
        <Route path="users/:id" element={<UserEdit />} />
        <Route path="quizzes" element={<QuizList />} />
        <Route path="quizzes/:id" element={<QuizEdit />} />
      </Route>
      <Route
        path="/dashboard"
        element={<RequireAuth>{<Navigation />}</RequireAuth>}
      >
        <Route path="/dashboard" element={<views.Dashboard />} />
        <Route
          path="/dashboard/blood-results"
          element={<views.BloodResultsDashboard />}
        />
        <Route
          path="/dashboard/refer-a-friend"
          element={<views.ReferFriend />}
        />
        <Route
          path="/dashboard/register-kit/:code"
          element={<views.KitRegistration />}
        />
        <Route
          path="/dashboard/register-kit"
          element={<views.KitRegistration />}
        />
        <Route path="/dashboard/blood-upload" element={<views.BloodUpload />} />
        {/* <Route path="/dashboard/account" element={<views.Account />} /> */}
        <Route path="/dashboard/connect" element={<views.Connect />} />
        <Route path="/dashboard/reports" element={<views.Reports />} />
        <Route
          path="/dashboard/blood-mineral-report"
          element={<views.BloodMineralInsights />}
        />
        <Route
          path="/dashboard/blood-vitamin-report"
          element={<views.BloodVitaminInsights />}
        />
        <Route path="/dashboard/blood-report" element={<views.BloodReport />} />

        <Route path="/dashboard/dna-report" element={<views.DnaReport />} />
        <Route path="/dashboard/survey/:code" element={<views.Survey />} />
        <Route path="/dashboard/onboarding" element={<views.PostQuizPage />} />

        <Route
          path="/dashboard/cortisol-report"
          element={<views.StressInsights />}
        />
        <Route path="/dashboard/icons" element={<views.Icons />} />
      </Route>
      <Route
        path="*"
        element={
          <RequireAuth>
            <views.Login />
          </RequireAuth>
        }
      />
    </Routes>
  );

  const navigationBarHeight = '36px';

  return (
    <BrowserRouter basename={'/'}>
      <ScrollToTop />
      <Box
        alignItems="center"
        justifyContent="center"
        marginTop={navigationBarHeight}
        sx={{
          display: { xs: 'block', sm: 'flex' },
        }}
      >
        <Box maxWidth="1440px">{viewSwitch}</Box>
      </Box>
    </BrowserRouter>
  );
}

export default App;
